import { useTranslation } from "react-i18next";

export default function useScopedTranslation(scope, ...params) {
  const { t } = useTranslation(...params);

  return (key, props) => t(scope ? scope + "." + key : key, props);
}
